var render = function render(_c, _vm) {
  return _vm.props.show
    ? _c(
        "div",
        { staticClass: "pricing_info", class: _vm.props.extraClasses },
        [
          _vm.props.isNewEquipment &&
          _vm.props.priceObject.main &&
          _vm.props.priceObject.main > 0 &&
          _vm.props.priceObject.main != 0.01
            ? _c("span", { staticClass: "starting_at" }, [
                _vm._v("Starting At"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.props.loading
            ? _c(
                "div",
                {
                  staticClass: "awaiting_overlay displayed partial dots_loader",
                },
                [_c("p", { attrs: { loader: "loading" } })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.props.priceObject.crossed &&
          _vm.props.showOld &&
          !_vm.props.loading
            ? _c("div", { staticClass: "crossPriceBox onSaleBadgeMarker" }, [
                _vm.props.priceObject.main &&
                _vm.props.priceObject.main > 0 &&
                _vm.props.priceObject.main != 0.01 &&
                !_vm.props.loading
                  ? _c("span", {
                      staticClass: "price",
                      domProps: {
                        textContent: _vm._s(
                          _vm.props.noCents
                            ? _vm.$options.filters.toCurrencyNoCents(
                                _vm.props.priceObject.main
                              )
                            : _vm.$options.filters.toCurrency(
                                _vm.props.priceObject.main
                              )
                        ),
                      },
                    })
                  : _c("span", { staticClass: "price call_for_price" }, [
                      _vm._v("Call for Price"),
                    ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "old_price",
                  domProps: {
                    textContent: _vm._s(
                      _vm.props.noCents
                        ? _vm.$options.filters.toCurrencyNoCents(
                            _vm.props.priceObject.crossed
                          )
                        : _vm.$options.filters.toCurrency(
                            _vm.props.priceObject.crossed
                          )
                    ),
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "cross_price_break" }),
                _vm._v(" "),
                _vm.props.priceObject.saving
                  ? _c("span", {
                      staticClass: "price_saving",
                      domProps: {
                        textContent: _vm._s(
                          "Save " +
                            _vm.$options.filters.toCurrency(
                              _vm.props.priceObject.saving
                            )
                        ),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "pi_onsale_badge",
                    staticStyle: { display: "none" },
                  },
                  [_vm._v("On Sale")]
                ),
              ])
            : _c("div", [
                _vm.props.priceObject.main &&
                _vm.props.priceObject.main > 0 &&
                _vm.props.priceObject.main != 0.01 &&
                !_vm.props.loading
                  ? _c("span", {
                      staticClass: "price",
                      domProps: {
                        textContent: _vm._s(
                          _vm.props.noCents
                            ? _vm.$options.filters.toCurrencyNoCents(
                                _vm.props.priceObject.main
                              )
                            : _vm.$options.filters.toCurrency(
                                _vm.props.priceObject.main
                              )
                        ),
                      },
                    })
                  : _c("span", { staticClass: "price call_for_price" }, [
                      _vm._v("Call for Price"),
                    ]),
              ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }